import {
  getSavedItems,
  SavedItems,
  SavedItemsExpandOption,
} from "@repo/apis/customers-saveditems-v3";
import { SavedItemsSdkMethod } from "../utils/method-initializer";
import { normalizeApiResponse } from "../utils/utils";

type PublicGetSavedItemsMethod = ({
  expand,
}: {
  expand?: SavedItemsExpandOption;
}) => Promise<SavedItems>;
type GetSavedItemsMethod = SavedItemsSdkMethod<PublicGetSavedItemsMethod>;

export const getSavedItemsInitializer: GetSavedItemsMethod =
  ({ state, getAuthHeaderPredicate, ...context }) =>
  async ({ expand }) => {
    try {
      const response = await getSavedItems({
        authHeader: await getAuthHeaderPredicate(),
        chameleonRequestInstance: context.chameleonRequestInstance,
        store: context.store,
        keyStoreDataversion: context.keyStoreDataversion,
        shop: context.shop,
        lang: context.lang,
        sizeSchema: context.sizeSchema,
        country: context.country,
        currency: context.currency,
        expand: expand || ["variants"],
      });

      const normalizedResponse = normalizeApiResponse(response);
      state.setSavedItemsState(normalizedResponse);

      return normalizedResponse;
    } catch (error) {
      console.error("Error getting saved items:", error);
      throw error;
    }
  };
